import React, { useEffect, useState } from "react";
import Footer from "../sections/common/Footer";
import Navbar from "../sections/common/Navbar";
import Pagination from "../sections/common/Pagination";
import { categoryListApi } from "../apis/propertylisting/propertyListApi";
import { useNavigate } from "react-router-dom";

const AllCategory = () => {
    const navigate = useNavigate()
    const [categoryData, setCategoryData] = useState(null)
    useEffect(() => {
        const fetchCategoryList = async () => {
            const response = await categoryListApi();
            const categoryList = response?.data?.data;
            setCategoryData(categoryList);
        };

        fetchCategoryList();
    }, []);

    return (
        <>
            <section>
                <Navbar />
                <section className="listing-banner">
                    <h1>All Properties</h1>
                </section>
                <section className="container blog-details-page-location">
                    <p>Home / All Properties</p>
                </section>

                <div className="explore-property">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 property-heading-col" style={{ paddingTop: "20px", paddingBottom: "0px" }}>
                                <h3>All Properties</h3>
                            </div>
                        </div>
                        <div className="row explore-row explore-detail-row py-3 gy-2">
                            {categoryData && categoryData?.category.map((property, index) => (
                                <div className="col-md-4" key={index} onClick={() => navigate(`/property-listing?property_type=${property.slug}-${property.id}`)}>
                                    <div className="explore-property-box" style={{ backgroundImage: `url(${property.image})`, cursor: "pointer" }}>
                                        <h5>{property.category_name}</h5>
                                        <p>{property.count}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <Pagination />
                <Footer />
            </section>
        </>
    )
}

export default AllCategory
